import React, { forwardRef } from 'react';

const Cell = forwardRef(({ children, ...attributes }, ref) => {
	return (
		<td ref={ref} {...attributes} className="py-2 px-3 border text-neutral-800 dark:text-white border-neutral-200 dark:border-neutral-700 transition-colors">
			{children}
		</td>
	);
});

export default Cell;